export default __webpack_public_path__ + "static/outsource@992_2x-a5b14c732ae5ea3468b43818b3141211.png";